<template>
    <div class="au-login">
        <div class="au-login-lang">
            <LanguageSwitch />
        </div>
        <div class="au-login-card">
            <div class="au-brand-logo au-login-logo"><i class="bi bi-shield-lock-fill"></i></div>
            <h1 class="au-login-title">{{ $t("auth.title") }}</h1>
            <p class="au-login-subtitle">{{ $t("auth.subtitle") }}</p>

            <div v-if="errorMessage" class="au-login-error" role="alert">
                <i class="bi bi-exclamation-circle-fill"></i>{{ errorMessage }}
            </div>

            <Form :validation-schema="schema" novalidate @submit="login">
                <bs5-form-field id="email" name="login" type="email" icon="bi-envelope" autocomplete="username"
                    :label="$t('auth.email')" :placeholder="$t('auth.emailPlaceholder')" v-model="model.login" />
                <bs5-form-field id="password" name="password" type="password" icon="bi-lock"
                    autocomplete="current-password" :label="$t('auth.password')"
                    :placeholder="$t('auth.passwordPlaceholder')" v-model="model.password" />
                <bs5-base-button variant="primary" type="submit" class="w-100 py-2 mt-2" :loading="loading">
                    <i v-if="!loading" class="bi bi-box-arrow-in-right"></i>{{ $t("auth.submit") }}
                </bs5-base-button>
            </Form>
        </div>
    </div>
</template>

<script lang="ts">
import { t } from "@/helpers/i18n";
import { defineComponent } from 'vue';
import { Form } from "vee-validate";
import * as yup from "yup";
import { useAuthStore } from "@/stores/auth.store";
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import { requiredEmail, requiredPassword } from "@/utils/validation";

export default defineComponent({
    components: { LanguageSwitch, Form },
    computed: {
        schema() {
            return yup.object({
                login: requiredEmail(),
                password: requiredPassword(),
            });
        },
    },
    data() {
        return {
            model: {
                login: '',
                password: ''
            },
            loading: false,
            errorMessage: '',
            authStore: useAuthStore(), // Inicjalizacja store'a w Options API
        };
    },
    methods: {
        async login() {
            this.loading = true;
            this.errorMessage = '';
            try {
                await this.authStore.login(this.model.login, this.model.password);
            }
            catch (error) {
                // Interceptor odrzuca 401 z obiektem błędu axios, a pozostałe błędy z samą odpowiedzią
                const failure = error as { status?: number; response?: { status?: number } };
                const status = failure?.response?.status ?? failure?.status;
                this.errorMessage = status === 401 ? t("auth.invalidCredentials") : t("auth.failed");
            }
            finally {
                this.loading = false;
            }
        }
    }
});
</script>
